import { SagaIterator } from 'redux-saga';
import { all, call, CallEffect, fork, ForkEffect, put, PutEffect, takeEvery, takeLatest } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IWorkbookDetailInfo } from '../../../../ts/models/IWorkbookInfo';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';
import { WindowLocationService } from '../../../../ts/services/WindowLocationService';
import { EditWorkbook } from '../../../actions/AppActionTypes';
import {
  requestFailed,
  RequestFailedAction
} from '../../../actions/RequestFailedAction';
import {
  removeFromContentSelection,
  RemoveFromContentSelectionAction
} from '../../../actions/spaces/ContentExplorerSelectionActions';
import { EditWorkbookAction } from '../../../actions/spaces/EditWorkbookAction';
import { ServiceLocator } from '../../../ServiceLocator';
import { openBlankWindow, setWindowLocation } from '../SpacesSagaHelpers';
import { fetchWorkbookById } from './WorkbookSagas';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit workbook saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards
export function* handleEditWorkbookAction(action: EditWorkbookAction) {
  let newWindow: Window = null;
  try {
    newWindow = openBlankWindow();
    const workbookInfo = yield call(fetchWorkbookById, action.workbook.id);
    setWindowLocation(newWindow, workbookInfo.editUrl);
  } catch (e) {
    newWindow && newWindow.close();
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
